import { RequestStage } from '../types/stages';

/** Partner requestor waiting on approval/reject outcome (#1456). */
export const REQUEST_DETAIL_AWAITING_REJECT_POLL_MS = 10_000;

/** Cap Draft-only polls so never-rejected Drafts do not poll forever. */
export const REQUEST_DETAIL_DRAFT_MISSING_REASON_POLL_CAP = 18;

export function shouldPollDetailForRejectionReadModel(params: {
  isOnline: boolean;
  requestStage: RequestStage | null;
  viewerIsRequestor: boolean;
  latestRejectionReason?: string;
  /** Vendor Approvals Group enabled with members — reject path is live. */
  partnerApprovalsActive: boolean;
  draftMissingReasonPollsDone: number;
}): boolean {
  if (
    !params.isOnline ||
    !params.viewerIsRequestor ||
    !params.partnerApprovalsActive
  ) {
    return false;
  }
  if (params.requestStage === RequestStage.AWAITING_APPROVAL) {
    return true;
  }
  if (
    params.requestStage === RequestStage.DRAFT &&
    !params.latestRejectionReason
  ) {
    return (
      params.draftMissingReasonPollsDone <
      REQUEST_DETAIL_DRAFT_MISSING_REASON_POLL_CAP
    );
  }
  return false;
}

/** Live approval queue: group members need fresh list rows when others submit (#1456). */
export function shouldPollRequestsListForApprovalQueue(params: {
  isOnline: boolean;
  partnerApprovalsActive: boolean;
  viewerIsLiveApprovalGroupMember: boolean;
}): boolean {
  return (
    params.isOnline &&
    params.partnerApprovalsActive &&
    params.viewerIsLiveApprovalGroupMember
  );
}

/** List rows omit rejection read-model; detail GET must hydrate Draft. */
export function shouldMarkDetailCacheNeedsRejectionHydration(
  listStage: string | undefined | null,
  existingRejectionReason: string | undefined,
): boolean {
  const normalized = listStage?.trim().toUpperCase();
  return normalized === RequestStage.DRAFT && !existingRejectionReason;
}
